import { Coins, KeyRound, Receipt, Sparkles } from "lucide-react";
import { usd } from "@/components/ai/useAiEdits";

// Three different measures that must never be confused: estimated USD, Universal Key credits, Emergent platform credits.
export default function CreditsLegend({ sum }) {
  const src = Object.fromEntries(sum.by_source.map((r) => [r.key_source, r]));
  const items = [
    ["usd", Receipt, "USD stimati", usd(sum.totals.usd), sum.legend.usd],
    ["universal", Sparkles, "Crediti Universal Key", `${usd(src.universal?.usd || 0)} stimati`, sum.legend.universal],
    ["own", KeyRound, "Chiavi personali", `${usd(src.own?.usd || 0)} stimati`, sum.legend.own],
    ["emergent", Coins, "Crediti Emergent", "Non usati dalle demo", sum.legend.emergent],
  ];
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="costs-legend">
      {items.map(([k, Icon, title, value, text]) => (
        <div key={k} className="rounded-xl border border-dashed border-slate-300 bg-slate-50/60 p-4" data-testid={`costs-legend-${k}`}>
          <p className="flex items-center gap-1.5 text-xs font-medium text-slate-700"><Icon size={13} className="text-sky-700" />{title}</p>
          <p className="mt-1.5 text-sm font-semibold text-slate-900 tabular-nums" data-testid={`costs-legend-${k}-value`}>{value}</p>
          <p className="mt-1.5 text-[11px] leading-snug text-slate-500">{text}</p>
        </div>
      ))}
    </div>
  );
}
